module.exports = __webpack_public_path__ + "static/media/background2.8ba5a083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/coinRunner/background2.png
// module id = 996
// module chunks = 0